import { z } from 'zod';
import { BaseErrorSchema } from 'libs/end-to-end/src/types/errors/base-error-schema';

export const S3ObjectNotFoundError = BaseErrorSchema.extend({
  errorType: z.literal('S3ObjectNotFoundError'),
  bucketName: z.string(),
  bucketRegion: z.string(),
  key: z.string(),
});

export type S3ObjectNotFoundError = z.infer<typeof S3ObjectNotFoundError>;
